export class PredictionStatus {
  static RUNNING = "Running";
  static COMPLETE = "Complete";
  static ERROR = "Error";
}